import Material from "../Materials"

export default function BackWall(params) {
  return (
      <mesh 
        castShadow
        receiveShadow
        position={[params.size/2, params.dim[2]/2, 0]}
        item={`backwall`}
      >
        <Material material={params.material} type={params.type} texture={params.texture}/> 
        <boxGeometry args={[params.size,params.dim[2],params.dim[0]-params.size*2]} />
      </mesh>
    )
  }

